// extracted by mini-css-extract-plugin
module.exports = {"root":"SideCart_root__38O1Z","fixed":"SideCart_fixed__3E-a_","checkoutButton":"SideCart_checkoutButton__1chgd"};